import * as React from 'react';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('./ContentHeader.scss');

/**
 * ContentHeader properties
 */
export interface ContentHeaderProps {
    text: string;
    colorScheme: ColorScheme;
    onClick: () => void;
}

/**
 * Content header for calendar views in split mode
 */
export function ContentHeader(props: ContentHeaderProps) {
    let { text, colorScheme, onClick } = props;
    return (
        <div
            className={styles.contentHeaderContainer}
            style={{ color: colorScheme.accessibleText.msColorWhiteBackground }}>
            <div className={styles.contentName}>{text}</div>
            <IconButton iconProps={{ iconName: ControlIcons.Cancel }} onClick={onClick} />
        </div>
    );
}
